export default "__VITE_PUBLIC_ASSET__b99882b1__"